import { Grid } from "@mui/material";
import { useTranslation } from "react-i18next";
import { HeaderDivider, LabelValue } from "components";
import { RegistrationJourneyState } from "journey";

export const PermissionToLeave = ({
  candidateDetails,
}: {
  candidateDetails: NonNullable<RegistrationJourneyState["candidateDetails"]>;
}) => {
  const { t } = useTranslation();

  return (
    <>
      <HeaderDivider
        text={t("details.permissionToLeaveTitle")}
        sx={{ mb: 3 }}
      />
      <Grid container spacing={2} sx={{ mb: 8 }}>
        <Grid size={{ xs: 12, md: 6 }}>
          <LabelValue
            label={t("details.permissionToLeave.canLeave.label")}
            value={
              candidateDetails.permissionToLeave?.canLeave
                ? t("details.permissionToLeave.canLeave.yes")
                : t("details.permissionToLeave.canLeave.no")
            }
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <LabelValue
            label={t("details.permissionToLeave.guardian.label")}
            value={candidateDetails.permissionToLeave?.guardianName}
          />
        </Grid>
        <Grid size={{ xs: 12, md: 6 }}>
          <LabelValue
            label={t("details.permissionToLeave.guardianPhone.label")}
            value={candidateDetails.permissionToLeave?.guardianPhone}
          />
        </Grid>
        {candidateDetails.permissionToLeave?.personCollectingCandidate && (
          <Grid size={{ xs: 12, md: 6 }}>
            <LabelValue
              label={t(
                "details.permissionToLeave.personCollectingCandidate.label"
              )}
              value={
                candidateDetails.permissionToLeave?.personCollectingCandidate
              }
            />
          </Grid>
        )}
      </Grid>
    </>
  );
};
